// API URLs
export const CORPORATE_SETTINGS_API = "/api/v1/corporate/setting";
export const MFA_GATEWAY_CHECK_API = "gateway/user/check";
export const MFA_GATEWAY_REQUEST_OTP_API =
  "gateway/mfa/requestEmailSessionVerificationToken";
export const MFA_GATEWAY_VERIFY_OTP_API =
  "gateway/mfa/verifyEmailSessionVerificationToken";
